"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleMappingRequestBodySchema = exports.RuleIdParamsSchema = exports.ListRulesQuerySchema = exports.ListRuleResponseSchema = exports.ListKeywordRuleResponseSchema = exports.ListRegionRuleResponseSchema = exports.ListCampaignRuleResponseSchema = exports.RuleResponseSchema = exports.KeywordRuleResponseSchema = exports.RegionRuleResponseSchema = exports.CampaignRuleResponseSchema = exports.SharedRuleSchemaFields = exports.UpdateRulePriorityBodySchema = exports.UpdateRuleBodySchema = exports.CreateRuleBodySchema = exports.RegionLevelRuleActionSchema = exports.RegionLevelRuleAction = exports.CampaignLevelRuleActionSchema = exports.CampaignLevelRuleAction = exports.RuleActionSchema = exports.RuleAction = exports.RulePropertySchema = exports.RuleProperty = exports.RuleConditionSchema = exports.RuleCondition = exports.RuleScopeSchema = exports.RuleScope = exports.RuleTypeSchema = exports.RuleType = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
var RuleType;
(function (RuleType) {
    RuleType["CAMPAIGN"] = "C";
    RuleType["REGION"] = "R";
    RuleType["KEYWORD"] = "K";
})(RuleType = exports.RuleType || (exports.RuleType = {}));
exports.RuleTypeSchema = (0, core_1.StringUnion)([...Object.values(RuleType)], {
    title: "Rule type",
    description: "The type of the rule, indicating what level object relates to",
});
var RuleScope;
(function (RuleScope) {
    RuleScope["CAMPAIGN"] = "CAMPAIGN";
    RuleScope["REGION"] = "REGION";
    RuleScope["KEYWORD"] = "KEYWORD";
})(RuleScope = exports.RuleScope || (exports.RuleScope = {}));
exports.RuleScopeSchema = (0, core_1.StringUnion)([...Object.values(RuleScope)], {
    title: "Rule scope",
    description: "The scope of the rule, indicating what level object applies to",
});
var RuleCondition;
(function (RuleCondition) {
    RuleCondition["GREATER_THAN"] = "GT";
    RuleCondition["LESS_THAN"] = "LT";
    RuleCondition["EQUAL"] = "EQ";
})(RuleCondition = exports.RuleCondition || (exports.RuleCondition = {}));
exports.RuleConditionSchema = (0, core_1.StringUnion)([...Object.values(RuleCondition)], {
    title: "Rule condition",
    description: "The comparison method used when applying the rule",
});
var RuleProperty;
(function (RuleProperty) {
    RuleProperty["COST_PER_DOWNLOAD"] = "COST_PER_DOWNLOAD";
    RuleProperty["BID_PRICE"] = "BID_PRICE";
    RuleProperty["IMPRESSIONS"] = "IMPRESSIONS";
    RuleProperty["TAPS"] = "TAPS";
    RuleProperty["DOWNLOADS"] = "DOWNLOADS";
    RuleProperty["AMOUNT_SPENT"] = "AMOUNT_SPENT";
    RuleProperty["CONVERSION_RATE"] = "CONVERSION_RATE";
})(RuleProperty = exports.RuleProperty || (exports.RuleProperty = {}));
exports.RulePropertySchema = (0, core_1.StringUnion)([...Object.values(RuleProperty)], {
    title: "Rule property",
    description: "The property of the keyword to assess",
});
var RuleAction;
(function (RuleAction) {
    RuleAction["SET_AS_NEGATIVE"] = "SET_AS_NEGATIVE";
    RuleAction["LOCK_BID_PRICE"] = "LOCK_BID_PRICE";
})(RuleAction = exports.RuleAction || (exports.RuleAction = {}));
exports.RuleActionSchema = (0, core_1.StringUnion)([...Object.values(RuleAction)], {
    title: "Rule action",
    description: "The action the rule will take when matched",
});
var CampaignLevelRuleAction;
(function (CampaignLevelRuleAction) {
    CampaignLevelRuleAction["SET_CPD_TARGET"] = "SET_CPD_TARGET";
    CampaignLevelRuleAction["STATUS"] = "STATUS";
})(CampaignLevelRuleAction = exports.CampaignLevelRuleAction || (exports.CampaignLevelRuleAction = {}));
exports.CampaignLevelRuleActionSchema = (0, core_1.StringUnion)([...Object.values(CampaignLevelRuleAction)], {
    title: "Campaign Level Rule action",
    description: "The action the rule will take when matched",
});
var RegionLevelRuleAction;
(function (RegionLevelRuleAction) {
    RegionLevelRuleAction["SET_CPD_TARGET"] = "SET_CPD_TARGET";
    RegionLevelRuleAction["STATUS"] = "STATUS";
})(RegionLevelRuleAction = exports.RegionLevelRuleAction || (exports.RegionLevelRuleAction = {}));
exports.RegionLevelRuleActionSchema = (0, core_1.StringUnion)([...Object.values(RegionLevelRuleAction)], {
    title: "Region Level Rule action",
    description: "The action the rule will take when matched",
});
exports.CreateRuleBodySchema = (0, core_1.StrictObject)({
    priority: typebox_1.Type.Number(),
    ruleCondition: exports.RuleConditionSchema,
    ruleProperty: exports.RulePropertySchema,
    ruleValue: typebox_1.Type.Number(),
    ruleAction: exports.RuleActionSchema,
    lookBackDays: typebox_1.Type.Number(),
    ruleActionValue: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    ruleScope: exports.RuleScopeSchema,
});
exports.UpdateRuleBodySchema = (0, core_1.StrictObject)({
    priority: typebox_1.Type.Number(),
    ruleCondition: exports.RuleConditionSchema,
    ruleProperty: exports.RulePropertySchema,
    ruleValue: typebox_1.Type.Number(),
    ruleAction: exports.RuleActionSchema,
    lookBackDays: typebox_1.Type.Number(),
    ruleActionValue: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    ruleScope: exports.RuleScopeSchema,
});
exports.UpdateRulePriorityBodySchema = typebox_1.Type.Array(typebox_1.Type.Object({
    ruleId: core_1.IdSchema,
    priority: typebox_1.Type.Number(),
}));
exports.SharedRuleSchemaFields = {
    id: core_1.IdSchema,
    priority: typebox_1.Type.Number(),
    ruleCondition: exports.RuleConditionSchema,
    ruleProperty: exports.RulePropertySchema,
    ruleValue: typebox_1.Type.Number(),
    ruleAction: exports.RuleActionSchema ||
        exports.CampaignLevelRuleActionSchema ||
        exports.RegionLevelRuleActionSchema,
    lookBackDays: typebox_1.Type.Number(),
    ruleActionValue: (0, core_1.OptionalNullable)(typebox_1.Type.Number()),
    ruleScope: exports.RuleScopeSchema,
    createdAt: typebox_1.Type.Number(),
    updatedAt: typebox_1.Type.Number(),
    status: ruby_1.RuleStatusSchema,
    type: exports.RuleTypeSchema,
};
exports.CampaignRuleResponseSchema = (0, core_1.StrictObject)({
    ...exports.SharedRuleSchemaFields,
    campaignIds: typebox_1.Type.Array(core_1.IdSchema),
    excludedRegionIds: typebox_1.Type.Array(core_1.IdSchema),
    excludedKeywordIds: typebox_1.Type.Array(core_1.IdSchema),
});
exports.RegionRuleResponseSchema = (0, core_1.StrictObject)({
    ...exports.SharedRuleSchemaFields,
    regionIds: typebox_1.Type.Array(core_1.IdSchema),
    excludedKeywordIds: typebox_1.Type.Array(core_1.IdSchema),
});
exports.KeywordRuleResponseSchema = (0, core_1.StrictObject)({
    ...exports.SharedRuleSchemaFields,
    keywordIds: typebox_1.Type.Array(core_1.IdSchema),
});
exports.RuleResponseSchema = typebox_1.Type.Union([
    exports.CampaignRuleResponseSchema,
    exports.RegionRuleResponseSchema,
    exports.KeywordRuleResponseSchema,
]);
exports.ListCampaignRuleResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.CampaignRuleResponseSchema);
exports.ListRegionRuleResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.RegionRuleResponseSchema);
exports.ListKeywordRuleResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.KeywordRuleResponseSchema);
exports.ListRuleResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.RuleResponseSchema);
exports.ListRulesQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.RuleIdParamsSchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    campaignId: core_1.IdSchema,
    ruleId: core_1.IdSchema,
}, {
    title: "Team, Campaign, and Rule",
    description: "Combined Team, Campaign, and Rule Id in a query parameter",
});
exports.RuleMappingRequestBodySchema = (0, core_1.StrictObject)({
    exclude: typebox_1.Type.Boolean(),
    regionIds: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema, {
        uniqueItems: true,
        title: "List of Region ids",
        description: "A list of the Region ids that a Rule maps to",
    })),
    keywordIds: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema, {
        uniqueItems: true,
        title: "List of Keyword ids",
        description: "A list of the Keyword ids that a Rule maps to",
    })),
});
